export default __webpack_public_path__ + "static/media/Placeholder.d988307a.png";